module.exports = __webpack_public_path__ + "img/gx_02.cc18ebdf.png";